
(function () {
  var SEARCH = '/search/suggest.json';


  /* Adds are driven by a button + data-variant-id, never a <form>.
     In the cart drawer this row renders inside <form id="CartDrawerForm">,
     and a nested form is invalid HTML - the inner submit posts the outer
     cart form and navigates to /cart instead of adding. */
  function addToCart(button) {
    var buttonText = button && button.querySelector('[data-add-to-cart-text]');
    var variantId = button && button.getAttribute('data-variant-id');
    if (!button || !buttonText || !variantId) return;

    var originalText = buttonText.textContent;
    button.classList.add('btn--loading');
    button.disabled = true;

    function reset(msg) {
      buttonText.textContent = msg;
      setTimeout(function () { buttonText.textContent = originalText; }, 2000);
      button.classList.remove('btn--loading');
      button.disabled = false;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status === 422) {
          reset(data.description || 'Error');
          return;
        }
        document.dispatchEvent(
          new CustomEvent('ajaxProduct:added', { detail: { product: data } })
        );
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.dispatchEvent(
              new CustomEvent('cart:updated', { detail: { cart: cart } })
            );
            reset('Added');
          });
      })
      .catch(function () {
        button.classList.remove('btn--loading');
        button.disabled = false;
      });
  }

  document.addEventListener('click', function (e) {
    var button = e.target && e.target.closest && e.target.closest('[data-cs-add]');
    if (!button) return;
    e.preventDefault();
    addToCart(button);
  });

  /* Inline size picker.

     A sized item used to add its first available variant silently in the
     drawer. Now the button opens a list of that product's variants, built from
     data-variants on the card, and the chosen one is added with the same
     add-to-cart path. Inline rather than a modal because the drawer is
     transformed and overflow-hidden, which clips position:fixed children. */
  function buildVariantList(item) {
    var existing = item.querySelector('.complete-set__variants');
    if (existing) return existing;

    var variants;
    try {
      variants = JSON.parse(item.getAttribute('data-variants') || '[]');
    } catch (err) {
      return null;
    }
    if (!variants.length) return null;

    var list = document.createElement('div');
    list.className = 'complete-set__variants';
    list.hidden = true;

    variants.forEach(function (v) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'complete-set__variant';
      if (v.available) {
        btn.setAttribute('data-cs-add', '');
        btn.setAttribute('data-variant-id', v.id);
      } else {
        btn.disabled = true;
        btn.className += ' complete-set__variant--soldout';
      }
      var label = document.createElement('span');
      label.setAttribute('data-add-to-cart-text', '');
      label.textContent = v.title;
      btn.appendChild(label);
      list.appendChild(btn);
    });

    item.appendChild(list);
    return list;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target && e.target.closest && e.target.closest('[data-cs-choose]');
    if (!trigger) return;
    e.preventDefault();

    var item = trigger.closest('.complete-set__item');
    if (!item) return;

    var list = buildVariantList(item);
    if (!list) return;

    var open = list.hidden;
    list.hidden = !open;
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });


  function preloadQuickShop(item) {
    if (item.dataset.csQuickReady === 'true') return;
    if (!window.theme || typeof theme.preloadProductModal !== 'function') return;
    if (!theme.settings || !theme.settings.quickView) return;
    if (theme.config && theme.config.bpSmall) return;

    var handle = item.dataset.productHandle;
    var id = item.dataset.productId;
    if (!handle || !id) return;
    if (!document.getElementById('QuickShopHolder-' + handle)) return;

    item.dataset.csQuickReady = 'true';
    theme.preloadProductModal(handle, id, item.querySelector('.complete-set__add'));
  }

  /* Skips the drawer: its transform + overflow:hidden make a position:fixed
     modal impossible to display, so those cards keep their product link. */
  function bindQuickShop(scope) {
    var items = (scope || document).querySelectorAll(
      '.complete-set:not(.complete-set--drawer) .complete-set__item[data-product-handle]'
    );
    Array.prototype.forEach.call(items, function (item) {
      if (item.dataset.csQuickBound === 'true') return;
      item.dataset.csQuickBound = 'true';
      var handler = function () { preloadQuickShop(item); };
      item.addEventListener('mouseover', handler);
      item.addEventListener('focusin', handler);
    });
  }

  function money(cents, currency) {
    var n = Number(cents);
    if (!isFinite(n)) return '';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'GBP'
      }).format(n / 100);
    } catch (e) {
      return (n / 100).toFixed(2);
    }
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function startsWith(title, prefix) {
    return title.toLowerCase().indexOf(prefix.toLowerCase()) === 0;
  }

  function fetchJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }


  /* Longest first, so the colourway beats the print family.
     "Fleur De Lys Aqua Scarf" tries "Fleur De Lys Aqua" before "Fleur De
     Lys" - otherwise the row mixes Aqua with Gold and Sand, which is not
     the set. Stops at the first prefix that returns anything, so the extra
     specificity usually costs no extra request.

     Never goes down to one word: "Amulet" alone would blend Gold, Green
     and Emerald together. */
  function prefixes(title) {
    var w = title.trim().split(/\s+/);
    var out = [];
    for (var n = Math.min(4, w.length - 1); n >= 2; n--) {
      out.push(w.slice(0, n).join(' '));
    }
    return out;
  }

  function findMatches(prefix, currentId, exclude, limit) {
    var url = SEARCH + '?q=' + encodeURIComponent(prefix) +
      '&resources[type]=product&resources[limit]=10';
    return fetchJSON(url).then(function (data) {
      var items = (data && data.resources && data.resources.results &&
        data.resources.results.products) || [];
      return items.filter(function (p) {
        if (!p || !p.title || !startsWith(p.title, prefix)) return false;
        if (String(p.id) === String(currentId)) return false;
        /* Never offer something already in the bag. */
        return exclude.indexOf(String(p.id)) === -1;
      }).slice(0, limit);
    });
  }

  function card(p, cfg) {
    var li = el('li', 'complete-set__item');

    var media = el('div', 'complete-set__media');
    var mediaLink = el('a', 'complete-set__media-link');
    mediaLink.href = p.url;
    mediaLink.setAttribute('tabindex', '-1');
    mediaLink.setAttribute('aria-hidden', 'true');
    if (p.featured_image) {
      var img = el('img', 'complete-set__img');
      img.src = p.featured_image;
      img.alt = '';
      img.loading = 'lazy';
      mediaLink.appendChild(img);
    }
    media.appendChild(mediaLink);

    if (cfg.showAdd) {
      var action = el('div', 'complete-set__action');
      var variants = p.variants || [];
      var firstAvailable = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].available) { firstAvailable = variants[i]; break; }
      }

      /* Mirrors the Liquid exactly: one-size items always add directly, and
         in the drawer a sized item adds its first AVAILABLE variant too -
         the cart re-renders showing the size, so a wrong pick is visible and
         removable on the spot. On the product page a sized item still links
         out, because an unnoticed default size would reach checkout. */
      var directAdd = firstAvailable && variants.length === 1;
      var needsChoice = firstAvailable && variants.length > 1 && cfg.addDefaultVariant;

      if (variants.length > 1) {
        li.setAttribute('data-variants', JSON.stringify(variants.map(function (v) {
          return {id: v.id, title: v.title, available: v.available};
        })));
      }

      if (directAdd) {
        // Button, not a form - see addToCart above for why.
        var btn = el('button', 'complete-set__add');
        btn.type = 'button';
        btn.setAttribute('data-cs-add', '');
        btn.setAttribute('data-variant-id', firstAvailable.id);
        btn.setAttribute('data-add-to-cart', '');
        var label = el('span', null, cfg.addLabel);
        label.setAttribute('data-add-to-cart-text', '');
        btn.appendChild(label);
        action.appendChild(btn);
      } else if (needsChoice) {
        var choose = el('button', 'complete-set__add complete-set__add--choose', cfg.chooseLabel);
        choose.type = 'button';
        choose.setAttribute('data-cs-choose', '');
        choose.setAttribute('aria-expanded', 'false');
        action.appendChild(choose);
      } else if (p.available) {
        var a = el('a', 'complete-set__add', cfg.chooseLabel);
        a.href = p.url;
        action.appendChild(a);
      } else {
        action.appendChild(
          el('span', 'complete-set__add complete-set__add--soldout', 'Sold out')
        );
      }

      media.appendChild(action);
    }

    li.appendChild(media);

    var link = el('a', 'complete-set__link');
    link.href = p.url;
    link.appendChild(el('span', 'complete-set__title', p.title));
    link.appendChild(el('span', 'complete-set__price', money(p.price, cfg.currency)));
    li.appendChild(link);

    return li;
  }

  function render(root, prefix, products, cfg) {
    var page = el('div', 'page-width');
    var panel = el('div', 'complete-set__panel');

    var header = el('div', 'complete-set__header');
    header.appendChild(
      el('h2', 'complete-set__heading',
        cfg.heading || cfg.headingPrefix + ' ' + prefix)
    );
    if (cfg.kicker) header.appendChild(el('p', 'complete-set__kicker', cfg.kicker));
    panel.appendChild(header);

    var ul = el('ul', 'complete-set__items');
    products.forEach(function (p) { ul.appendChild(card(p, cfg)); });
    panel.appendChild(ul);

    if (cfg.showViewAll) {
      var all = el('a', 'complete-set__all',
        cfg.viewAllPrefix + ' ' + prefix + ' ' + cfg.viewAllSuffix);
      all.href = '/search?q=' + encodeURIComponent(prefix);
      panel.appendChild(all);
    }

    page.appendChild(panel);
    root.appendChild(page);
    root.style.setProperty('--cs-cols', String(products.length));
    root.hidden = false;
  }

  function boot(root) {
    if (!root || root.dataset.csReady === 'true') return;
    root.dataset.csReady = 'true';

    var title = root.dataset.productTitle || '';
    var limit = parseInt(root.dataset.limit, 10) || 3;

    var cfg = {
      currency: root.dataset.currency,
      heading: root.dataset.heading || '',
      headingPrefix: root.dataset.headingPrefix || '',
      kicker: root.dataset.kicker || '',
      addLabel: root.dataset.addLabel || 'Add',
      chooseLabel: root.dataset.chooseLabel || 'Choose size',
      showAdd: root.dataset.showAdd === 'true',
      addDefaultVariant: root.dataset.addDefaultVariant === 'true',
      showViewAll: root.dataset.showViewAll === 'true',
      viewAllPrefix: root.dataset.viewAllPrefix || 'See all',
      viewAllSuffix: root.dataset.viewAllSuffix || 'pieces'
    };

    var excludeIds = (root.dataset.excludeIds || '')
      .split(',').map(function (s) { return s.trim(); }).filter(Boolean);

    var tries = prefixes(title);
    if (!tries.length) return;

    (function attempt(i) {
      if (i >= tries.length) return; // nothing found - row stays hidden
      var prefix = tries[i];

      findMatches(prefix, root.dataset.productId, excludeIds, limit)
        .then(function (found) {
          if (!found.length) return attempt(i + 1);

          return Promise.all(found.map(function (p) {
            return fetchJSON(p.url.split('?')[0] + '.js')
              .then(function (full) {
                return {
                  id: full.id,
                  title: full.title,
                  url: p.url,
                  price: full.price,
                  available: full.available,
                  variants: full.variants,
                  featured_image: full.featured_image || p.featured_image
                };
              })
              .catch(function () { return null; });
          })).then(function (detailed) {
            /* Sold out pieces are dropped here rather than in findMatches:
               the search payload does not carry stock, the per-product .js
               fetch does. */
            var clean = detailed.filter(function (p) {
              return p && p.available;
            });
            if (clean.length) render(root, prefix, clean, cfg);
          });
        })
        .catch(function () { /* network failure - leave the row hidden */ });
    })(0);
  }

  /* Prev/next arrows for the cart-drawer row. The row is a horizontal
     scroll-snap strip, which touch devices swipe but a mouse cannot, so
     arrows go in the header. CSS only shows them on hover-capable pointers.
     Runs on every init, so rows rendered later (search fallback, cart
     re-renders) pick them up; data-cs-nav stops a second set. */
  var ARROW = '<svg aria-hidden="true" focusable="false" viewBox="0 0 16 16"><path d="M10 3 5 8l5 5" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
  var navCount = 0;

  // Hide the arrows when everything fits, and grey out the end you are at.
  function updateArrows(root) {
    var list = root.querySelector('.complete-set__items');
    var nav = root.querySelector('.complete-set__nav');
    if (!list || !nav) return;
    var max = list.scrollWidth - list.clientWidth;
    nav.hidden = max <= 1;
    nav.firstChild.disabled = list.scrollLeft <= 1;
    nav.lastChild.disabled = list.scrollLeft >= max - 1;
  }

  function updateAllArrows() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.complete-set--drawer[data-cs-nav]'),
      updateArrows
    );
  }

  function bindDrawerArrows(scope) {
    var rows = (scope || document).querySelectorAll('.complete-set--drawer');
    Array.prototype.forEach.call(rows, function (root) {
      var header = root.querySelector('.complete-set__header');
      var list = root.querySelector('.complete-set__items');
      if (!header || !list || root.dataset.csNav === 'true') return;
      root.dataset.csNav = 'true';
      if (!list.id) list.id = 'CompleteSetItems-' + (++navCount);

      var nav = el('div', 'complete-set__nav');
      [['prev', 'Previous', -1], ['next', 'Next', 1]].forEach(function (cfg) {
        var btn = el('button', 'complete-set__arrow complete-set__arrow--' + cfg[0]);
        btn.type = 'button';
        btn.setAttribute('aria-label', cfg[1]);
        btn.setAttribute('aria-controls', list.id);
        btn.innerHTML = ARROW;
        btn.addEventListener('click', function () {
          // One card per click: the card width plus the flex gap.
          var card = list.querySelector('.complete-set__item');
          var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
          var step = card ? card.getBoundingClientRect().width + gap : list.clientWidth;
          list.scrollBy({ left: step * cfg[2], behavior: 'smooth' });
        });
        nav.appendChild(btn);
      });
      header.appendChild(nav);

      list.addEventListener('scroll', function () { updateArrows(root); }, { passive: true });
      updateArrows(root);
    });
  }

  // Registered once for every row. The drawer is display:none until it
  // opens, so widths read 0 on the first pass and need measuring again.
  window.addEventListener('resize', updateAllArrows);
  document.addEventListener('drawerOpen', function () {
    requestAnimationFrame(updateAllArrows);
  });

  function init(scope) {
    bindQuickShop(scope);
    var nodes = (scope || document).querySelectorAll('[data-complete-set-search]');
    Array.prototype.forEach.call(nodes, boot);
    bindDrawerArrows(scope);
  }

  /* Why a MutationObserver rather than the cart events.

     theme.js:1884 calls buildCart() - which is ASYNC, it fetches
     cart.ajax and resolves on a later tick - and then dispatches
     cart:updated synchronously on the very next line. So by the time
     cart:updated fires, the drawer still holds the OLD markup: scanning
     then finds no search container, and when the real markup lands
     nothing scans it again. Same for ajaxProduct:added.

     [data-products] is the container cartMarkup empties and re-fills
     (theme.js:1789), so watching it is the one signal guaranteed to
     arrive after the new cards exist. theme.js is a vendor file, so this
     stays on our side of the boundary rather than patching its ordering.

     Re-entry is safe: boot() marks a container csReady before rendering
     into it, so the mutations it causes are ignored on the way back in. */
  function watchCartContainers() {
    var containers = document.querySelectorAll('[data-products]');
    Array.prototype.forEach.call(containers, function (node) {
      if (node.dataset.csObserved === 'true') return;
      node.dataset.csObserved = 'true';
      new MutationObserver(function () { init(node); })
        .observe(node, { childList: true, subtree: true });
    });
  }

  function start() {
    init(document);
    watchCartContainers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    watchCartContainers();
  });

  /* Kept as a backstop for the cart PAGE, where main-cart.liquid renders
     [data-products] server-side and no mutation follows. The drawer relies
     on the observer above, not on these - see watchCartContainers. */
  document.addEventListener('cart:updated', start);
  document.addEventListener('ajaxProduct:added', start);
  document.addEventListener('drawerOpen', start);
})();
